import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
export const usePersonalDataStore = (storage) => create()(persist((set) => ({
    personalDetails: {},
    setPersonalDetails: (data) => set((state) => ({
        personalDetails: { ...state.personalDetails, ...data },
    })),
    clearPersonalDetails: () => set(() => ({ personalDetails: {} })),
}), {
    name: 'personalDetails',
    storage: createJSONStorage(() => storage || sessionStorage),
}));
